import React, { useEffect, useState } from 'react';
import usePost from '../../../Hooks/usePost';
import { BrainLoader } from '../../../Components/Generics.styled';
import propTypes from 'prop-types';
import { createChatBotMessage } from 'react-chatbot-kit';

const SupportGPT = ({ state, setState, actions, userInput }) => {
    const { post } = usePost('/davieLLM');

    const [gptPostData, setGptPostData] = useState({
        isLoading: false,
        error: false,
        success: false,
    });

    const askDavie = async () => {
        setGptPostData({ ...gptPostData, isLoading: true });

        try {
            const davieResp = await post({ question: userInput }, 'POST');
            const response = davieResp?.data?.answer?.content;
            if (response) {
                setGptPostData({ ...gptPostData, isLoading: false });
                const message = createChatBotMessage(response);

                setState((prev) => ({
                    ...prev,
                    messages: [...prev.messages, message],
                }));

                setTimeout(() => {
                    const subsequentMessage = createChatBotMessage(
                        'Do you need help with anything else?'
                    );

                    setState((prev) => ({
                        ...prev,
                        messages: [...prev.messages, subsequentMessage],
                    }));
                }, 1000); // 5000 milliseconds = 5 seconds
            }
        } catch (err) {
            setGptPostData({ ...gptPostData, isLoading: false, error: true });
            const message = createChatBotMessage('Shhhhh!, Im taking a nap right now!');

            setState((prev) => ({
                ...prev,
                messages: [...prev.messages, message],
                userInput: userInput,
            }));
        }

        // setGptResp(response)
    };

    useEffect(() => {
        askDavie();
    }, []);

    return <div>{gptPostData?.isLoading ? <BrainLoader width="100px" /> : null}</div>;
};

SupportGPT.propTypes = {
    actions: propTypes.shape({}),
    state: propTypes.shape({ messages: propTypes.array, userInput: propTypes.string }),
    setState: propTypes.func,
    userInput: propTypes.string,
};

export default SupportGPT;
